import styles from './_popularPlaylist.module.scss'
import { SONGS_LIST_QUERY } from '../../../gql/queries'
import SongComponent from '../../../components/SongComponent'
import { FilterValues } from '../../../components/ui/ListSort'
import { useQuery } from '@apollo/client'
import { SortSongsEnum, VibeEnum } from '../../../__generated__/graphql'

interface QueryVariables {
  orderBy?: SortSongsEnum.CurrentlyTrending | SortSongsEnum.GreatestHits
  vibeId?: VibeEnum
}

const buildPopularPlaylist = (vars: QueryVariables, songList?): React.FC => {
  const PopularPlaylistComponent: React.FC = () => {
    const { data } = useQuery(SONGS_LIST_QUERY, {
      variables: { perPage: 10, ...vars },
      skip: songList?.length
    })

    const songs = songList || data?.songs

    if (!songs) return <></>

    const list = songs.map((song, index) => {
      return (
        <div
          className="column is-one-fifth-tablet is-half-mobile"
          key={song.id}
        >
          <SongComponent
            song={song}
            displayEditButton={true}
            priority={index >= 0 && index < 6}
          />
        </div>
      )
    })
    return (
      <div
        className={`${styles.currentlyTrending} columns is-mobile is-multiline`}
      >
        {list}
      </div>
    )
  }

  return PopularPlaylistComponent
}

export default buildPopularPlaylist
